export default "__VITE_ASSET__BP4J6N92__"